import ShopifyClient from "shopify-buy"
import store from "store"

import UserInfo from "src/helpers/UserInfo"

const userInfo = new UserInfo()

export default class Shopify {
  // Keep an array of custom attributes for shopify
  customAttributes = []
  // We need to expose an async function to setup our class
  // properties based on cache
  build = async () => {
    try {
      this.checkout = await this.getCheckout()
      this.customAttributes = this.checkout.customAttributes
    } catch (err) {
      console.error(err)
    }
  }

  // Setup the shopify client
  client = ShopifyClient.buildClient({
    domain: "graston-technique.myshopify.com",
    storefrontAccessToken: "b7476aa485a1d0869e532a3e090d59d5",
  })

  //TODO: break out into a constants file
  /*
  All of these ids are retrievable via shopify's graphql api
  https://help.shopify.com/en/api/storefront-api/getting-started#example-queries
  */

  // Define the known variant IDs that we want to check for
  variants = {
    E1_TRAINING_ID: "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTMwNDcyOTkxOTU5MA==",
    RESERVATION_ID: "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8xNzk4NjE2MDM5NDM1NQ=="
  }

  // Define the known product IDs that we want to check for
  products = {
    INSTRUMENTS: "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0Lzk3MDY4Mjk5MDcwNw==",
    INSTR_RESERVE: "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0LzE4NDM2NTI5ODQ5NDc=",
    E1_TRAINING: "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0LzQ0OTQyMzU5NTkzOTg="
  }

  promoCodes = {
    instrumentDiscount: "INST_SAVE_500",
  }

  /*
  GraphQL query for the product variant ids
    {
      collectionByHandle(handle: "all-in-one") {
        id
        products(first: 50) {
          edges {
            node {
              id
              title
              variants(first: 50) {
                edges {
                  node {
                    id
                    title
                    }
                  }
                }
              }
            }
          }
        }
      }
  */

  promoCodeRequirements = [
    {
      name: 'EquineBundle',
      code: 'GT-EQUINE-SET',
      variantIDs: [
        // E1 Training
        'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTMwNDcyOTkxOTU5MA=='
      ]
    }
  ]

  // These are the ID of the collections we want to use on this site
  collections = {
    instruments: "Z2lkOi8vc2hvcGlmeS9Db2xsZWN0aW9uLzQ0OTcxMzYwMzcx",
    announcementProduct: "Z2lkOi8vc2hvcGlmeS9Db2xsZWN0aW9uLzE1NDE0NzE2MDE2Ng==",
    equineProducts: "Z2lkOi8vc2hvcGlmeS9Db2xsZWN0aW9uLzE1NTE5NjY4NjQzOA==",
    EquineBundle: "Z2lkOi8vc2hvcGlmeS9Db2xsZWN0aW9uLzE1NTE5NzY2OTQ3OA=="
  }

  // Check the users local storage for a cached checkout, else create one
  getCheckout = async () => {
    try {
      const cart = store.get("shopifyCart")

      if (cart != null && cart.id) {
        const checkout = await this.client.checkout.fetch(cart.id)

        if (checkout && !checkout.completed_at) {
          this.cachedCheckout = true

          return await this.client.checkout.fetch(cart.id)
        }
        store.remove("shopifyCart")
      }

      await this.addUserShippingInfo()

      const checkout =
        this.shippingInfo &&
        this.shippingInfo.address1 != "" &&
        this.shippingInfo.city != "" &&
        this.shippingInfo.province != "" &&
        this.shippingInfo.zip != "" &&
        this.shippingInfo.country != "" &&
        this.shippingInfo.company != "" &&
        this.shippingInfo.lastName != "" &&
        this.shippingInfo.firstName != "" &&
        this.shippingInfo.phone != ""
          ? await this.client.checkout.create({
              shippingAddress: this.shippingInfo,
            })
          : await this.client.checkout.create()

      store.set("shopifyCart", {
        id: checkout.id,
      })

      return checkout
    } catch (err) {
      console.error(err)
    }
  }

  // Get the collection using our defined collection ID
  getCollection = async collectionToRetrieve => {
    try {
      return await this.client.collection.fetchWithProducts(
        collectionToRetrieve
      )
    } catch (err) {
      console.error(err)
    }
  }

  // Get specific products by variant ids
  getProducts = async products => {
    try {
      return await this.client.product.fetchMultiple(products)
    } catch (err) {
      console.error(err)
    }
  }

  // Get client ID from cookies
  getClientInfoCookie = () => {
    const cookies = document.cookie.split("; ")

    for (let i = 0; i < cookies.length; i++) {
      if (cookies[i].includes("client_id")) {
        const clientInfo = cookies[i].split("=")[1]

        if (clientInfo != null) {
          this.clientInfo = {
            key: "client_id",
            value: clientInfo,
          }
        }
      }
    }
  }

  // Get user info from cookies
  getUserInfoCookie = () => {
    const tokens = store.get("tokens")

    const newUserId = store.get("newUserId")

    let userId

    if (tokens && tokens.userId) {
      userId = tokens.userId
    } else if (newUserId) {
      userId = newUserId
    } else {
      userId = null
    }

    this.userInfo = {
      key: "userId",
      value: userId,
    }
  }

  // See if the client ID exists in the cookies
  cookieAttrExists() {
    const attributes = this.checkout.customAttributes

    const clientInfo = attributes.filter(attr => attr.key === "client_id")

    return clientInfo.length > 0
  }

  // Add an item to the users checkout
  addToCart = async (type, object) => {
    try {
      // Assigns this.clientInfo
      this.getClientInfoCookie()

      // Assigns this.userInfo
      this.getUserInfoCookie()

      if (this.cachedCheckout) {
        if (!this.cookieAttrExists) {
          this.addClientInfo()
        }
      } else this.addClientInfo()

      this.addUserCookieInfo()

      await this.handleType(type, object)

      const checkout = await this.client.checkout.updateAttributes(
        this.checkout.id,
        {
          customAttributes: this.customAttributes,
        }
      )

      this.checkout = checkout
    } catch (err) {
      console.error(err)
    }
  }

  addBundleToCart = async bundle => {
    try {
      const checkout = await this.client.checkout.addLineItems(
        this.checkout.id,
        bundle
      )

      this.checkout = checkout

      await this.checkForDiscountEligibility()
    } catch (err) {
      console.error(err)
    }
  }

  // Update the shopify cart
  updateCart = async itemsToUpdate => {
    try {
      const checkout = await this.client.checkout.updateLineItems(
        this.checkout.id,
        itemsToUpdate
      )

      this.checkout = checkout

      return checkout
    } catch (err) {
      console.error(err)
    }
  }

  // Add client info to custom attrs
  addClientInfo = () => {
    if (this.clientInfo) {
      this.addToCustomAttributes(this.clientInfo)
    }
  }

  // Add user cookie info to custom attrs
  addUserCookieInfo = () => {
    if (this.userInfo.value) {
      this.addToCustomAttributes(this.userInfo)
    }
  }

  // Add user shipping info to custom attrs
  addUserShippingInfo = async () => {
    const userTokens = store.get("tokens")
    if (userTokens) {
      await userInfo.build()

      this.shippingInfo = {
        address1: userInfo.user.Account.ShippingStreet || "",
        city: userInfo.user.Account.ShippingCity || "",
        province: userInfo.user.Account.ShippingState || "",
        zip: userInfo.user.Account.ShippingPostalCode || "",
        country: userInfo.user.Account.ShippingCountry || "",
        company: userInfo.user.Account.Name || "",
        lastName: userInfo.user.LastName || "",
        firstName: userInfo.user.FirstName || "",
        phone: userInfo.user.Phone || "",
      }
    }
  }

  // Handle the different types of things we can put in the cart (slightly different logic)
  handleType = async (type, object) => {
    try {
      switch (type) {
        case "training":
          await this.handleTraining(object)
          break
        case "instruments":
          await this.handleInstruments(object)
          break
        case "product":
          await this.handleProducts(object)
          break
        default:
          console.error("Shopify item type not recognized.")
          break
      }

      await this.checkForDiscountEligibility()
    } catch (err) {
      console.error(err)
    }
  }

  // Handle the training items
  handleTraining = async object => {
    try {
      this.addToCustomAttributes({
        key: "trainingId",
        value: object.Id,
      })

      const checkout = await this.client.checkout.updateAttributes(
        this.checkout.id,
        { customAttributes: this.customAttributes }
      )

      this.checkout = checkout

      let isInCart = false

      this.checkout.lineItems.forEach(item => {
        if (
          item.variant.id === this.variants.E1_TRAINING_ID
        )
          isInCart = true
      })

      if (!isInCart) {
        let variantId
        switch (object.Module__c) {
          case "E1":
            variantId = this.variants.E1_TRAINING_ID
            break
          default:
            console.error("Training type not recognized.")
            break
        }

        this.checkout = await this.client.checkout.addLineItems(
          this.checkout.id,
          {
            variantId: variantId,
            quantity: 1,
            customAttributes: {
              key: "type",
              value: "Training",
            },
          }
        )
      }
    } catch (err) {
      console.error(err)
    }
  }

  // Handle adding instruments to the shopify cart
  handleInstruments = async object => {
    try {
      const productId =
        object && (object.variants ? object.variants[0].id : null)

      let itemsToRemove = []

      // If this function is called with nothing (no instruments)
      // we want to remove the current instruments, else we want to
      // make sure the object has variants before we remove them
      if (object == null || object.hasOwnProperty("variants")) {
        this.checkout.lineItems.forEach(item => {
          const variantId = item.variant.id

          if (
            variantId === this.variants.RESERVATION_ID ||
            variantId === this.variants.COMPLETE_SET
          ) {
            itemsToRemove.push(item.id)
          }
        })
      }

      if (itemsToRemove.length > 0) {
        this.checkout = await this.client.checkout.removeLineItems(
          this.checkout.id,
          itemsToRemove
        )
      }

      let isInCart = false

      this.checkout.lineItems.find(item => {
        if (item.variants) isInCart = item.variants[0].id === productId
      })

      if (productId && !isInCart) {
        this.checkout = await this.client.checkout.addLineItems(
          this.checkout.id,
          {
            variantId: productId,
            quantity: 1,
          }
        )
      }
    } catch (err) {
      console.error(err)
    }
  }

  // Handle basic/normal products
  handleProducts = async object => {
    try {
      this.checkout = await this.client.checkout.addLineItems(
        this.checkout.id,
        {
          variantId: object.variantId,
          quantity: object.quantity,
        }
      )
    } catch (err) {
      console.error(err)
    }
  }

  // Remove line item from cart
  removeLineItem = async object => {
    try {
      if (this.determineIfTraining(object)) {
        let indexToRemove

        this.customAttributes.forEach((attr, index) => {
          if (attr.key === "trainingId") {
            indexToRemove = index
          }
        })

        if (indexToRemove) {
          this.customAttributes.splice(indexToRemove)
        }

        if (this.customAttributes) {
          this.customAttributes = this.formatCustomAttributes()
        }

        this.checkout = await this.client.checkout.updateAttributes(
          this.checkout.id,
          { customAttributes: this.customAttributes }
        )
      }

      const checkout = await this.client.checkout.removeLineItems(
        this.checkout.id,
        [object.id]
      )

      this.checkout = checkout

      await this.checkForDiscountEligibility()
    } catch (err) {
      console.error(err)
    }
  }

  // Adds unique item to customAttributes
  addToCustomAttributes = itemToAdd => {
    let tempCustomAttributes = []

    if (this.customAttributes.length > 0) {
      tempCustomAttributes = this.customAttributes.filter(note => {
        return note.key !== itemToAdd.key
      })
    }

    tempCustomAttributes.push(itemToAdd)

    this.customAttributes = tempCustomAttributes
  }

  determineIfTraining = object => {
    const { customAttributes } = object
    if (!customAttributes.length) return false

    return new Boolean(customAttributes.find(attr => attr.value === "Training"))
  }

  /*Shopify sdk doesn't like to accept the attributes 
  it returns, so we must reformat the objects first*/
  formatCustomAttributes = () => {
    return this.customAttributes.map(attr => {
      const { key, value } = attr

      return { key, value }
    })
  }

  checkForDiscountEligibility = async () => {
    const { lineItems, discountApplications } = this.checkout

    if (lineItems.length <= 1) return

    const validDiscountCode = this.promoCodeRequirements.find(discountRules =>
      discountRules.variantIDs.every(Id => {
        return lineItems.some(item => {
          return item.variant.id === Id
        })
      })
    )

    if (validDiscountCode) {
      const codeAlreadyUsed = discountApplications.some(
        exApp => exApp.code === validDiscountCode.code
      )

      if (!codeAlreadyUsed) {
        await this.addDiscount(validDiscountCode)
      }
    } else {
      const codeNeedsRemoved = discountApplications.find(exApp =>
        this.promoCodeRequirements.some(req => req.code === exApp.code)
      )
      if (codeNeedsRemoved) {
        await this.removeDiscount(codeNeedsRemoved)
      }
    }
  }

  addDiscount = async discount => {
    try {
      this.checkout = await this.client.checkout.addDiscount(
        this.checkout.id,
        discount.code
      )
    } catch (err) {
      console.error(err)
    }
  }

  removeDiscount = async discount => {
    try {
      this.checkout = await this.client.checkout.removeDiscount(
        this.checkout.id,
        discount.code
      )
    } catch (err) {
      console.error(err)
    }
  }
}
